{
  "form": {
    "closeLabel": "Close event inquiry"
  },
  "thankYou": {
    "body": "Your event inquiry has been received."
  },
  "configError": {
    "label": "Event inquiry unavailable"
  },
  "submittedForm": {
    "collapseLabel": "Collapse inquiry details",
    "expandLabel": "Expand inquiry details"
  },
  "smsConsent": {
    "label": "Text me for follow-ups on this inquiry."
  },
  "status": {
    "updatingInquiry": "Updating your inquiry",
    "updatingInquiryDetails": "Updating the inquiry details"
  }
}
